import type {ImmersivePlugin} from '../plugin/copilot-immersive-plugin'

export function getActivePluginFromLocation(
  location: {pathname: string},
  plugins: ImmersivePlugin[],
): ImmersivePlugin | undefined {
  const {pathname} = location
  if (!pathname) return
  // we should not call p.matchThread() here because that depends on state.messages and that changes a lot and would cause a lot of re-renders
  return plugins.find(p => p.matchPage?.(pathname) || p.matchView?.(pathname))
}
